<template>
    <svg
        t="1610004663578"
        class="icon"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="22077"
        :width="size"
        :height="size"
        fill="rgb(191, 166, 109)"
    >
        <path
            d="M225.536 567.168c-6.144 7.296-9.024 16.64-8.768 28.032 0.256 11.392 3.968 20.736 10.944 28.032 6.976 7.296 16.32 10.944 28.032 10.944h83.968c-2.944 8.768-4.672 17.216-5.248 25.344-0.576 8.192-0.576 16.64 0 25.344 0 33.856 3.968 65.792 11.84 95.808 7.872 30.08 18.816 57.92 32.832 83.584H204.992c-31.488-1.152-57.728-12.224-78.72-33.28s-32.064-47.232-33.28-78.72v-543.36c1.152-31.488 12.224-57.856 33.28-79.168 20.992-21.312 47.232-32.256 78.72-32.832h487.36c31.488 0.576 57.856 11.52 79.168 32.832s32.256 47.68 32.832 79.168v145.28c-16.896-8.192-35.712-14.016-56.448-17.472-20.736-3.52-40.96-4.928-60.8-4.352h-6.144c-2.944-5.824-6.848-10.176-11.84-13.12-4.992-2.944-10.368-4.352-16.192-4.352H244.352c-8.768 0-16.512 2.944-23.168 8.768-6.72 5.824-10.048 14.272-10.048 25.344s3.328 19.712 10.048 25.792c6.72 6.144 14.464 10.624 23.168 13.568h258.112c-33.856 19.264-63.168 42.88-87.936 70.848-24.832 28.032-44.16 60.352-58.176 97.152H255.744c-14.016-0.128-24.064 3.52-30.208 10.816z m627.392-51.2c44.608 42.56 67.84 96.832 69.568 162.752-1.728 66.496-24.96 121.92-69.568 166.272s-99.904 67.392-165.824 69.12c-66.496-1.728-121.92-25.344-166.272-70.848s-67.392-100.352-69.12-164.48c1.728-62.976 24.768-116.544 69.12-160.576 44.352-44.032 99.776-66.944 166.272-68.672 65.92 1.728 121.216 23.872 165.824 66.432z m-19.648 231.04c6.4-6.4 9.6-14.016 9.6-22.72s-3.2-16.448-9.6-23.168c-6.4-6.72-14.016-10.368-22.72-10.944h-118.144V566.72c0-8.768-3.392-16.32-10.048-22.72-6.72-6.4-14.464-9.6-23.168-9.6s-16.512 3.2-23.168 9.6c-6.72 6.4-10.368 14.016-10.944 22.72v157.504c0.576 8.768 4.224 16.32 10.944 22.72 6.72 6.4 14.464 9.92 23.168 10.496h151.36c8.704-0.512 16.256-4.032 22.72-10.432z"
            p-id="22078"
            fill="rgb(191, 166, 109)"
        ></path>
    </svg>
</template>
<script>
export default {
    props: {
        size: {
            type: String,
            default: "10vw",
        },
    },
};
</script>
